import { Injectable } from '@angular/core';

const _global = (window /* browser */) /* node */ as any;

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor() {}

  /**
   * Update icon rendering
   */
  public update() {
    _global.friconix_update();
  }
}
